import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MedKitNumberField } from '@bigpicturemedical/medkit'
import { DvQuantity, IPath } from '@bigpicturemedical/openehr-vue'
import { BlockContainer, BlockHeader, BlockPanel } from './_layout'


export default /*#__PURE__*/_defineComponent({
  __name: 'PulseHeartBeatBlock',
  props: {
    path: null,
    name: null,
    description: null,
    errors: null
  },
  setup(__props: any) {

const props = __props as {
  path: IPath
  name: string
  description: string
  errors: Array<string> // TODO: Display this
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BlockContainer), { class: "space-y-6" }, {
    default: _withCtx(() => [
      _createVNode(_unref(BlockHeader), null, {
        heading: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.name), 1)
        ]),
        description: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.description), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(BlockPanel), { class: "p-6 grid gap-4" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DvQuantity), {
            path: props.path.add('rate')
          }, {
            default: _withCtx(({ name, description, unitOptions, min, max, magnitude, unit, setMagnitude, setUnit, validate, validateIfAlreadyValidated, errors, required }) => [
              _createVNode(_unref(MedKitNumberField), {
                "model-value": magnitude,
                unit: unit,
                label: name,
                min: min,
                max: max,
                "help-text": description,
                "unit-options": unitOptions,
                error: errors[0],
                required: required,
                "onUpdate:modelValue": setMagnitude,
                "onUpdate:unit": setUnit,
                onInput: validateIfAlreadyValidated,
                onBlur: validate
              }, null, 8, ["model-value", "unit", "label", "min", "max", "help-text", "unit-options", "error", "required", "onUpdate:modelValue", "onUpdate:unit", "onInput", "onBlur"])
            ]),
            _: 1
          }, 8, ["path"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})